module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_2.79c365b2.png";